/* global __BLUEHQ_GOOGLE_ANALYTICS_TRACKING_ID__ */

import CurrentUserIdStore from "./stores/CurrentUserIdStore";
import CurrentOrganizationStore from "./stores/CurrentOrganizationStore.js";
import CurrentOrganizationIdStore from "./stores/CurrentOrganizationIdStore.js";
import ReactGA from "react-ga4";

function updateAnalyticsUserId() {
  const userId = CurrentUserIdStore.getState();
  ReactGA.set({ userId });
  ReactGA.gtag("set", "user_properties", { bluehq_user_id: userId });
}

function updateAnalyticsOrg() {
  const org = CurrentOrganizationStore.getState();
  const org_id = org ? org.get("id") : null;
  ReactGA.gtag("set", { org_id });
  if (org && org.get("gaTag") != null) {
    // NOTE: if we ever added the ability to switch orgs without reloading the page, we will
    // need to figure out how to turn off a config. Or we would have to skip this config entirely
    // and just log page views to the custom property with send_to
    ReactGA.gtag("config", org.get("gaTag"), { send_page_view: false });
    updateAnalyticsUserId();
  }
}

export function initializeAnalytics() {
  ReactGA.initialize(__BLUEHQ_GOOGLE_ANALYTICS_TRACKING_ID__, {
    legacyDimensionMetric: false,
  });

  CurrentUserIdStore.addListener(updateAnalyticsUserId);
  CurrentOrganizationStore.addListener(updateAnalyticsOrg);
  updateAnalyticsUserId();
  updateAnalyticsOrg();
}

export function logPageView(location) {
  if (!location.pathname.startsWith("/content/")) {
    logPageViewRaw({ location });
  }
}

export function logPageViewRaw({ location, page_title }) {
  const org_id = CurrentOrganizationIdStore.getState();
  ReactGA.gtag("event", "page_view", {
    page_path: location.pathname,
    page_title,
    org_id,
  });
}
